import { UnitValue } from '../../models/data-structures/unit-value.model';
import { UnitService } from '../../helper/anessa-library/anessa-library/projects/unit-library/src/public-api';
import { Feedstock } from '../../models/project/feedstock/feedstock.model';

export default class FeedstockUtil {
  static getNormalizedMassPerDay(f: Feedstock, unitService: UnitService): number {
    const mass: UnitValue = f.quantities.getMass();
    const time: UnitValue = f.quantities.period;

    const massInKg = unitService.getValueInBaseUnit(mass);
    const timeInDays = unitService.getValueInBaseUnit(time);

    return (massInKg / 1000) / timeInDays;
  }
}
